"use strict";
(function (global) {

  /** 
  * Ссылка на объект.
  *
  * @class WebAccess.Link
  * @mixes WebAccess.mixins.linkMixin
  * @param {Integer} id Идентификатор объекта
  * @param {OBJECT_TYPE} type Тип объекта
  * @param {String} [opt_referenceName] Имя справочника
  * @property {Integer} id Идентификатор объекта
  * @property {OBJECT_TYPE} type Тип объекта
  * @property {String} referenceCode Имя справочника
  * @property {String} className Имя класса
  * @since 5.0.0.7300  
  */
  var Link = Class.extend([global.mixins.linkMixin], {
    className: "Link",
    id: 0,
    type: OBJECT_TYPE.UNKNOWN,
    referenceName: null,
    isNew: false,

    init: function (id, type, opt_referenceName) {
      if (isNaN(id) && typeof id !== 'object') {
        this.id = WA.CR.getID();
        this.type = WA.CR.getObjectType();
        this.referenceName = WA.CR.getReferenceCode();
        return this;
      }

      if (typeof id === 'object') {
        this.id = id['id'];
        this.type = id['type'];
        this.referenceName = id['referenceName'];
      } else {
        this.id = id;
        this.type = type;
        this.referenceName = opt_referenceName;
      }
      return this;
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      
  });

  global.Link = Link;
})(window.WebAccess);